<template>
  <div class="w-4 h-4 bg-white rounded-full" />
</template>
